import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ErrorComponent from '../../../../shared-components/ErrorComponent/ErrorComponent';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import _ from 'lodash';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import DEFooter from '../../../components/Footer/DEFooter/DEFooter';
import NoSessionFooter from '../../../components/Footer/NoSessionFooter/NoSessionFooter';
import './ErrorPage.less';
import { connect } from 'react-redux';
import { ERROR } from '../../../../framework/App/AppConstants';

const HIDE_CTA_ERROR_TYPES = ['noSession', 'wiredOff'];
const HIDE_CTA_STATUS_CODES = [401, 404];

export class GuestErrorPage extends Component {
    static propTypes = {
        errorType: PropTypes.string,
        statusCode: PropTypes.number,
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    render() {
        const { errorType, statusCode } = this.props;
        const isNoSession = errorType === ERROR.TYPE.NO_SESSION;
        let hideCtaButton = false;
        if (HIDE_CTA_ERROR_TYPES.includes(errorType)) {
            hideCtaButton = true;
        } else if (HIDE_CTA_STATUS_CODES.includes(statusCode)) {
            hideCtaButton = true;
        }
        return (
            <div className="de-wrapper">
                <div className="ErrorPage">
                    <ErrorComponent
                        hideCtaButton={hideCtaButton}
                        Header={Header}
                        Footer={Footer}
                        ContentFooter={isNoSession ? NoSessionFooter : DEFooter}
                    />
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    errorType: _.get(state, 'serverData.errorModel.errorType', 'ppCredit'),
    statusCode: _.get(state, 'serverData.errorModel.statusCode', null)
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_errorpage', 'prepare_pp_credit_errorpage'));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(GuestErrorPage);
